import React from 'react';

const EmployeeTitle = ({ record }) => {
	return <span>Employee {record ? `"${record.name}"` : ''}</span>;
};

export default EmployeeTitle;
